<template>
  <div class="page-wrapper">
    <div class="page-content">
      <div class="comfirmOrder">
        <SearchNav />
        <div class="page-title-wrapper">
          <span class="page-title">订单确认</span>
        </div>
        <p class="comfirmOrder-title">确认收货地址</p>
        <div class="comfirmOrder-address">
          <div class="comfirmOrder-address-title">
            <span>药店名称：{{ preAddress.companyName }}</span>
            <span v-if="!hasAuth" class="rz">未认证</span>
            <span v-else class="rz no">已认证</span>
          </div>
          <div class="comfirmOrder-address-detail">
            <img class="address-icon" :src="require('@/assets/img/location-icon.png')" alt="" />
            <p>{{ preAddress.merchantAddr }}</p>
          </div>
          <div class="comfirmOrder-address-person">
            <div class="person-sec">
              <p :key="item.addrId" v-for="item in preAddress.receiverList" class="person-row">
                <el-radio v-model="preOrderInfo.addressId" :label="item.addrId">
                  <!-- <span class="info name">{{ item.receiverName }}</span> -->
                  <span class="info">
                    <span>{{ item.receiverName }}</span>
                    &nbsp;&nbsp;{{ item.receiverMobile }}
                  </span>
                </el-radio>
                <span class="btn edit" @click="onPersonInfoedit(item)">编辑</span>
                <span class="btn del" @click="onDeletePersonInfo(item)">删除</span>
              </p>
            </div>
            <div class="create-new-address" @click="createReceivePerson">新增收货人信息</div>
          </div>
        </div>
        <p class="comfirmOrder-title">支付方式</p>
        <div class="comfirmOrder-pay">
          <ChooseTab :tabList="payIdOptions" :activeVal="payId" @change="onPayTypeChange" />
        </div>
        <p class="comfirmOrder-title">确认订单信息</p>
        <div class="comfirmOrder-order" v-for="(info, index) in preOrderInfo.merchantItemInfos" :key="index">
          <div class="comfirmOrder-order-left">
            <p class="comfirmOrder-order-left-title">
              <img v-if="info.shopIcon && info.shopIcon != ''" :src="info.shopIcon" alt="" class="shop-logo" />
              <img v-else :src="require('@/assets/img/shop-logo.png')" class="shop-logo" />
              {{ info.shopName }}&nbsp;&nbsp;&nbsp;&nbsp;{{ info.merchantEntityName }}
            </p>
            <div class="comfirmOrder-order-left-content">
              <div class="top">
                <p class="comfirmOrder-order-left-content-des">配送说明</p>
                <p class="comfirmOrder-order-left-content-des" style="display: flex">
                  配送商：
                  <span>
                    {{ info.merchantEntityName }}
                    <br />
                    {{ info.shopName }}
                  </span>
                </p>
              </div>
              <p class="cert-tip">提示：首次在店铺下单，记得勾选首营资料哦</p>
              <p class="business">
                随货资质需求：
                <span class="file" @click="onCheckCertification(info)">
                  {{ renderFollowGoodsCertification(info) }}
                </span>
              </p>
            </div>
          </div>
          <div class="comfirmOrder-order-right">
            <div class="top-space"></div>
            <div class="comfirmOrder-order-right-content">
              <div class="comfirmOrder-order-right-content-detail" v-for="item in info.itemList" :key="item.cartId">
                <img
                  v-if="item.itemThumbnail"
                  :src="item.itemThumbnail + '?x-oss-process=image/resize,w_180/quality,q_90'"
                  alt=""
                />
                <img v-else :src="require('@/assets/img/goods-empty.png')" alt="" />
                <div class="comfirmOrder-order-right-content-detail-des">
                  <p class="name">{{ item.itemName }}</p>
                  <p class="sku">{{ item.spec }}</p>
                  <p class="address">{{ item.enterprise }}</p>
                  <img
                    class="kuaiyao-tag"
                    :src="require('@/assets/img/o2o-vip.svg')"
                    alt=""
                    v-if="item.fastDrugMemberFlag"
                  />
                </div>
                <p class="comfirmOrder-order-right-content-detail-price">¥{{ price(item.realPrice) }}</p>
                <p class="comfirmOrder-order-right-content-detail-num">x{{ item.num }}</p>
                <p class="comfirmOrder-order-right-content-detail-all">¥{{ price(item.realPrice * item.num) }}</p>
              </div>
              <div class="comfirmOrder-order-right-content-remark">
                备注
                <el-input class="remark-ipt" maxlength="100" v-model="info.remark" placeholder="请输入内容"></el-input>
              </div>
              <div class="price-info">
                <!-- <p class="kind">共{{ (info.itemList || []).length }}种商品 x {{ goodAmount(info.itemList || []) }}</p> -->
                <p class="yunfei">
                  运费：
                  <span v-if="info.shippingAmount" class="item-value">
                    ¥
                    <span class="weight">{{ price(info.shippingAmount) }}</span>
                  </span>
                  <span v-else class="item-value">
                    <span class="">包邮</span>
                  </span>
                </p>
                <!-- <p v-if="info.discountAmount" class="youhui">
                  优惠
                  <span class="money">¥{{ price(info.discountAmount) }}</span>
                </p> -->
                <p class="total-money">
                  合计：
                  <span class="money">¥{{ price(info.totalAmount) }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        <p class="comfirmOrder-title">发票信息</p>
        <div class="comfirmOrder-invoice-sec">
          <div class="invoice-top">
            <div class="" v-if="preOrderInfo.invoiceId">
              <span>{{ preOrderInfo.invoiceType }}</span>
              <span class="invoice-title">{{ preOrderInfo.invoiceName }}</span>
              <span @click="onChooseInvoice" class="change-invoice pointer">修改</span>
            </div>
            <div class="" v-else @click="onChooseInvoice">
              <span class="change-invoice pointer">选择发票类型</span>
            </div>
          </div>
        </div>
        <div class="comfirmOrder-pay-sec">
          <div class="pay-content">
            <div class="pay-content-row">
              <p class="row-key goods-all-price">
                已选择
                <span class="orange">{{ getTotalItem }}</span>
                种商品，数量
                <span class="orange">x {{ getTotalNum }}</span>
                商品总额：
              </p>
              <p class="row-val">¥{{ price(preOrderInfo.totalItemRealPrice) }}</p>
            </div>
            <div v-if="preOrderInfo.discountAmount" class="pay-content-row">
              <p class="row-key">优惠金额：</p>
              <p class="row-val">-¥{{ price(preOrderInfo.discountAmount) }}</p>
            </div>
            <div class="pay-content-row">
              <p class="row-key">运费：</p>
              <p class="row-val">¥{{ price(preOrderInfo.shippingAmount) }}</p>
            </div>
            <div class="pay-content-row real-price-row">
              <p class="row-key real-pay-key">实付款：</p>
              <p class="row-val real-pay-val">¥{{ price(preOrderInfo.totalAmount) }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-footer">
      <div class="page-footer-content">
        <div class="page-footer-content__back">
          <img class="arrow-img" :src="require('@/assets/img/back-arrow.png')" alt="" />
          <span @click="onBackShop">返回购物车</span>
        </div>
        <div class="page-footer-content__submitBtn" @click="submitOrder">提交订单</div>
      </div>
    </div>
    <ReceiveAddress
      @ok="getAddressList"
      :editItem="editItem"
      :title="addressTitle"
      :receiveType="receiveType"
      :preAddress="preAddress"
      ref="receiveDialogRef"
    />
    <CertificationDialog :info="certificationInfo" ref="certificationDialogRef" />
    <ChooseInvoiceDialog ref="chooseInvoiceDialogRef" />
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import SearchNav from '@/components/SearchNav';
import ChooseTab from '@/pages/Order/components/ChooseTab';
import ReceiveAddress from '@/pages/Order/components/ReceiveAddress';
import CertificationDialog from '@/pages/Order/components/CertificationDialog';
import ChooseInvoiceDialog from '@/pages/Order/components/ChooseInvoiceDialog.vue';
import { priceFenToYuan, throttle } from '@/helpers/utils';

import * as api from '@/services';
export default {
  name: 'confirmOrder',
  components: {
    SearchNav,
    ChooseTab,
    ReceiveAddress,
    CertificationDialog,
    ChooseInvoiceDialog
  },
  computed: {
    ...mapState('order', ['preOrderInfo']),
    getTotalItem() {
      let num = 0;
      (this.preOrderInfo.merchantItemInfos || []).map((item) => {
        num += item.itemList.length;
      });
      return num;
    },
    getTotalNum() {
      let num = 0;
      (this.preOrderInfo.merchantItemInfos || []).map((item) => {
        item.itemList.map((o) => {
          num += o.num;
        });
      });
      return num;
    }
  },
  data() {
    return {
      editItem: {},
      addressTitle: '',
      receiveType: 'add',
      payId: 2,
      payIdOptions: [
        {
          value: 2,
          label: '对公转账'
        }
      ],
      preAddress: {},
      hasAuth: false,
      certificationInfo: {}
    };
  },
  mounted() {
    Telescope.trackPage({
      trackId: 'zyb2bpc-page-ddy-qrddyB2B'
    });
    this.setPreOrderInfo({
      ...JSON.parse(window.localStorage.getItem('preOrderInfo'))
    });
    this.$store.dispatch('layout/SET_FOOTER', false);
    this.autoChooseInvoice();
    if (!this.preOrderInfo.addressId) {
      this.getAddress();
      this.getAuth();
    }
    const payId_0_tips = []; // 在线支付 提示（存在即置灰）
    const payId_2_tips = []; // 对公转账 提示
    const payId_103_tips = []; // 他人代付
    this.preOrderInfo?.merchantItemInfos?.forEach((item) => {
      if (!item.payIds.includes(0)) {
        payId_0_tips.push(item.shopName); // 该店铺不支持在线支付
        payId_103_tips.push(item.shopName); // 该店铺不支持他人代付（不支持在线支付即不支持他人代付）
      }
      if (!item.payIds.includes(2)) {
        payId_2_tips.push(item.shopName); // 该店铺不支持对公转账
      }
    });
    this.payIdOptions = [
      {
        value: 0,
        label: '在线支付',
        tips: payId_0_tips
      },
      {
        value: 103,
        label: '他人代付',
        tips: payId_103_tips
      },
      {
        value: 2,
        label: '对公转账',
        tips: payId_2_tips
      }
    ];
    if (!payId_0_tips.length) {
      this.payId = 0;
    } else {
      this.payId = 2;
    }
  },
  beforeDestroy() {
    this.$store.dispatch('layout/SET_FOOTER', true);
  },
  methods: {
    ...mapActions('order', ['setPreOrderInfo']),
    async autoChooseInvoice() {
      // 默认选中专用发票
      const invoice = await api.personal.getInvoiceDetail({ invoiceType: 1 });
      if (invoice.invoiceId) {
        this.setPreOrderInfo({
          ...this.preOrderInfo,
          invoiceId: invoice.invoiceId,
          invoiceType: '专用发票',
          invoiceName: invoice.name
        });
      }
    },
    renderFollowGoodsCertification(info) {
      let word = '';
      if (info.merchantQualifications && info.merchantQualifications.length) {
        word = info.merchantQualifications.join('、');
        word = '企业资质: ' + word;
        word = word + '、';
      }
      let drugText = '';
      let sellText = '';
      (info.itemList || []).map((o) => {
        if (o.drugReport) {
          drugText = drugText + `${o.itemName}、`;
        }
        if (o.sellQualification) {
          sellText = sellText + `${o.itemName}、`;
        }
      });
      if (drugText) {
        word = word + '商品药检报告: ' + drugText;
      }
      if (sellText) {
        word = word + '商品首营资料: ' + sellText;
      }
      return word;
    },
    async recalcOrder() {
      const params = {
        orderSource: 4,
        addressId: this.preOrderInfo.addressId
      };
      let merchantParams = [];
      // 重组下单参数
      this.preOrderInfo.merchantItemInfos.map((item) => {
        let obj = {};
        obj.merchantId = item.merchantId;
        obj.shopId = item.shopId;
        obj.cartIds = item.itemList.map((o) => {
          return o.cartId;
        });
        obj.merchantCouponIds = [];
        item.validCoupons.map((o) => {
          if (o.selected) {
            obj.merchantCouponIds = [o.id];
          }
        });
        obj.followGoodsCertification = {};
        obj.followGoodsCertification.merchantQualifications = item.merchantQualifications;
        obj.followGoodsCertification.itemQualifications = item.itemList.map((o) => {
          return {
            itemId: o.itemCode,
            itemName: o.itemName,
            itemThumbnail: o.itemThumbnail || '',
            drugReport: true,
            sellQualification: o.sellQualification || false
          };
        });
        merchantParams.push(obj);
      });
      params.merchantInfos = merchantParams;
      params.platformCouponIds = this.preOrderInfo.platformCouponIds;
      const res = await api.order.calcPreOrder(params);
      res.merchantItemInfos.map((item) => {
        // 默认选中订单内所有商品的“商品药检报告”
        item.itemList.forEach((v) => {
          v.drugReport = true;
          v.sellQualification = false;
        });
      });
      this.setPreOrderInfo({
        ...this.preOrderInfo,
        merchantItemInfos: res.merchantItemInfos,
        validPlatformCoupons: res.validPlatformCoupons,
        invalidPlatformCoupons: res.invalidPlatformCoupons,
        platformCouponIds: res.platformCouponIds,
        platformCouponAmount: res.platformCouponAmount,
        discountAmount: res.discountAmount,
        totalItemRealPrice: res.totalItemRealPrice,
        shippingAmount: res.shippingAmount,
        totalAmount: res.totalAmount
      });
    },
    async getAddress() {
      const data = await api.personal.getReceiveAddr();
      this.preAddress = data;
      if (data.receiverList?.length) {
        this.setPreOrderInfo({
          ...this.preOrderInfo,
          addressId: data.receiverList[0].addrId,
          addressInfo: data.receiverList[0]
        });
      }
    },
    async getAddressList(chooseUser) {
      const data = await api.personal.getReceiveAddr();
      this.preAddress = data;
      if (chooseUser) {
        if (data.receiverList?.length) {
          this.setPreOrderInfo({
            ...this.preOrderInfo,
            addressId: data.receiverList[0].addrId,
            addressInfo: data.receiverList[0]
          });
        }
      }
    },
    async getAuth() {
      const authInfo = await api.personal.getPurchaseAuthDetail();
      this.hasAuth = authInfo.isAuth;
    },
    onChooseInvoice() {
      this.$refs.chooseInvoiceDialogRef.dialogVisible = true;
    },
    goodAmount(items) {
      const amount = items.reduce((total, item) => {
        return total + item.num;
      }, 0);
      return amount;
    },
    price(val) {
      return priceFenToYuan(val);
    },
    // 支付方式改变
    onPayTypeChange(event) {
      this.payId = event.value;
    },
    // 新增收货人信息
    createReceivePerson() {
      if (this.preAddress.receiverList?.length >= 20) {
        this.$message('收货人数量已达上限');
        return;
      }
      this.receiveType = 'add';
      this.addressTitle = '新增收货人信息';
      this.$refs.receiveDialogRef.dialogVisible = true;
    },
    // 编辑收货人信息
    onPersonInfoedit(item) {
      this.receiveType = 'edit';
      this.editItem = item;
      this.addressTitle = '修改收货人信息';
      this.$refs.receiveDialogRef.dialogVisible = true;
    },
    // 删除收货人信息
    onDeletePersonInfo(item) {
      this.$confirm('确定要删除该收货人吗？', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        cancelButtonClass: 'custom_confirm_button',
        confirmButtonClass: 'custom_confirm_button',
        title: null,
        alignFooter: 'right',
        type: 'warning'
      })
        .then(async () => {
          await api.personal.delReceiveAddr({ addrId: item.addrId }).then((res) => {
            this.$message.success('删除成功！');
            if (item.addrId === this.preOrderInfo.addressId) {
              this.setPreOrderInfo({
                ...this.preOrderInfo,
                addressId: ''
              });
            }
            this.getAddressList(true);
          });
        })
        .catch(() => {});
    },
    // 查看企业资质
    onCheckCertification(info) {
      this.certificationInfo = info;
      this.$refs.certificationDialogRef.dialogVisible = true;
    },
    // 返回购物车
    onBackShop() {
      this.$router.back();
    },
    // 提交订单
    submitOrder: throttle(async function () {
      Telescope.trackEvent({
        trackId: 'zyb2bpc-event-ddy-qrddydjtjanB2B'
      });

      const deviceId = Telescope.getClientInfo()?.deviceId || 'unknow';

      if (!this.preOrderInfo.addressId) {
        this.$alert('请选择收货地址', '提示', {
          confirmButtonText: '确定',
          cancelButtonClass: 'custom_confirm_button',
          confirmButtonClass: 'custom_confirm_button',
          alignFooter: 'right'
        });
        return;
      }
      if (!this.preOrderInfo.invoiceId) {
        this.$alert('您还未选择发票信息，请先选择发票信息再提交订单', '提示', {
          confirmButtonText: '确定',
          cancelButtonClass: 'custom_confirm_button',
          confirmButtonClass: 'custom_confirm_button',
          alignFooter: 'right'
        });
        return;
      }
      this.topOffset = 0;
      const params = {
        orderSource: 4,
        payId: this.payId === 103 ? 0 : this.payId, // 服务端他人代付（103）实际还是在线支付（0）
        addressId: this.preOrderInfo.addressId
      };
      params.invoiceId = this.preOrderInfo.invoiceId;
      let merchantParams = [];
      // 重组下单参数
      this.preOrderInfo.merchantItemInfos.map((item) => {
        let obj = {};
        obj.merchantId = item.merchantId;
        obj.shopId = item.shopId;
        if (item.remark) {
          obj.remark = item.remark;
        }
        obj.cartIds = item.itemList.map((o) => {
          return o.cartId;
        });
        obj.merchantCouponIds = [];
        item.validCoupons.map((o) => {
          if (o.selected) {
            obj.merchantCouponIds = [o.id];
          }
        });
        obj.followGoodsCertification = {};
        obj.followGoodsCertification.merchantQualifications = item.merchantQualifications;
        obj.followGoodsCertification.itemQualifications = item.itemList.map((o) => {
          return {
            itemId: o.itemCode,
            itemName: o.itemName,
            itemThumbnail: o.itemThumbnail || '',
            drugReport: true,
            sellQualification: o.sellQualification || false
          };
        });
        merchantParams.push(obj);
      });
      params.merchantInfos = merchantParams;
      params.platformCouponIds = this.preOrderInfo.platformCouponIds;
      params.totalAmount = this.preOrderInfo.totalAmount;
      params.deviceId = deviceId;
      api.order
        .submitOrder(params)
        .then(async (res) => {
          window.localStorage.removeItem('preOrderInfo');
          if (this.payId === 103) {
            // 他人代付
            this.$router.replace(`/pay_payOnBehalf/${res.mainOrderSn}`);
            return;
          }
          if (this.payId === 0) {
            // 在线支付
            this.$router.replace(`/pay_onlinePayment/${res.mainOrderSn}/${res.tradeNo}`);
            return;
          }
          if (res.forward === 1) {
            // 线上支付
            this.$router.replace(`/orderPay/${res.orderSns[0]}`);
          } else if (res.forward === 2) {
            this.$router.replace(
              `/orderPay/${res.orderSns[0]}?isLot=true&totalAmount=${this.preOrderInfo.totalAmount}`
            );
          } else if (res.forward === 3) {
            // 对公转账
            this.$router.replace(`/orderPay/${res.orderSns[0]}`);
          } else if (res.forward === 4) {
            // this.$router.replace(`orderDetail?orderSn=${res.orderSns[0]}`);
            this.$router.replace(`/orderPay/${res.orderSns[0]}`);
          }
        })
        .catch((error) => {
          if (error.error.code === 'SHARE_ORDER-ORDER-AMOUNT_ERROR') {
            this.$alert(error.error.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonClass: 'custom_confirm_button',
              confirmButtonClass: 'custom_confirm_button',
              alignFooter: 'right'
            }).then(() => {
              this.recalcOrder();
            });
          } else {
            this.$alert(error.error.message, '提示', {
              confirmButtonText: '确定',
              cancelButtonClass: 'custom_confirm_button',
              confirmButtonClass: 'custom_confirm_button',
              alignFooter: 'right'
            });
          }
        });
    }, 2000)
  }
};
</script>

<style lang="scss" scoped>
.page-wrapper {
  display: flex;
  flex-direction: column;
  height: inherit;
  .page-content {
    flex: 1;
    overflow-y: scroll;
    padding-bottom: 94px;
    .comfirmOrder {
      width: 1232px;
      margin: 0 auto;
      .page-title-wrapper {
        display: flex;
        align-items: center;
        .page-title {
          font-size: 24px;
          font-weight: 500;
          color: #333333;
          margin-right: 179px;
        }
        .order-tip-wrapper {
          width: 616px;
          height: 32px;
          background-color: #fff7db;
          .tip {
            line-height: 32px;
            font-size: 12px;
            font-weight: 400;
            color: #555555;
          }
        }
      }
      &-title {
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 12px;
        margin-top: 24px;
      }
    }
    .comfirmOrder-address {
      background: #fafafa;
      border: 0.5px dashed #8c8c8c;

      &-title {
        font-size: 18px;
        font-weight: 400;
        color: #333333;
        height: 50px;
        display: flex;
        align-items: center;
        border-bottom: 0.5px dashed #8c8c8c;
        padding: 0 16px;
        .rz {
          display: inline-block;
          height: 18px;
          width: 44px;
          background: #e7f3ff;
          border-radius: 1px;
          line-height: 18px;
          font-size: 12px;
          text-align: center;
          font-weight: 400;
          vertical-align: middle;
          margin-left: 11px;
          color: #8c8c8c;
          &.no {
            color: #1e8dff;
          }
        }
      }
      &-detail {
        display: flex;
        align-items: center;
        min-height: 48px;
        padding: 16px;
        border-bottom: 1px dashed #bfbfbf;
        .address-icon {
          width: 16px;
          height: 16px;
          margin-right: 4px;
        }
        p {
          font-size: 16px;
          font-weight: 400;
          color: #727272;
          line-height: 24px;
        }
      }

      &-person {
        padding: 16px;
        ::v-deep .el-radio__input.is-checked .el-radio__inner {
          background: transparent;
          &::after {
            width: 8px;
            height: 8px;
            background: #1e8dff;
          }
        }
        ::v-deep .el-radio {
          margin-right: 8px;
          display: flex;
          flex-direction: row;
          align-items: center;
        }
        .person-sec {
          display: flex;
          flex-wrap: wrap;

          .person-row {
            width: 33%;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            .btn {
              font-size: 12px;
              font-weight: 400;
              color: #1e8dff;
              cursor: pointer;
            }
            .edit {
              margin-right: 12px;
            }
            .info {
              font-size: 12px;
              font-weight: 400;
              color: #727272;
              display: flex;
              align-items: center;
              span {
                max-width: 160px;
                overflow: hidden;
                text-overflow: ellipsis;
                line-height: 14px;
                display: inline-block;
              }
            }
          }
        }
        .create-new-address {
          width: 116px;
          height: 24px;
          line-height: 24px;
          text-align: center;
          font-size: 12px;
          font-weight: 400;
          color: #ffffff;
          background: #1e8dff;
          cursor: pointer;
        }
      }
    }
    .comfirmOrder-pay {
      &-btn {
        width: 184px;
        height: 32px;
        font-size: 12px;
        border: 0.5px dashed #8c8c8c;
        line-height: 32px;
        text-align: center;
        display: inline-block;
        margin-right: 8px;
        cursor: pointer;
      }
      .active {
        border: 1px solid #1e8dff;
        background: url('../../../assets/img/trian-right-icon.png') right bottom no-repeat;
        background-size: 17px 17px;
      }
    }
    .comfirmOrder-order {
      display: flex;
      margin-bottom: 18px;
      border: 0.5px dashed #8c8c8c;
      background: #fafafa;

      &-left {
        display: inline-block;
        width: 400px;
        box-sizing: border-box;
        &-title {
          display: flex;
          align-items: center;
          font-size: 14px;
          font-weight: 400;
          color: #333333;
          height: 45px;
          padding: 0 16px;
          border-bottom: 1px solid #dfdfdf;
          .shop-logo {
            width: 30px;
            height: 30px;
            margin-right: 8px;
          }
          .flagship {
            font-size: 10px;
            background: #ff3737;
            border-radius: 1px;
            font-size: 12px;
            color: #fff;
            padding: 0px 4px;
            margin-left: 8px;
            margin-right: 4px;
          }
        }
        &-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          padding: 16px;
          height: calc(100% - 45px);
          &-des {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            margin-bottom: 12px;
          }
          &-tips {
            font-size: 12px;
            font-weight: 400;
            color: #888888;
          }
          .business {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            display: flex;
            width: 370px;
            white-space: nowrap;
            .file {
              cursor: pointer;
              font-size: 12px;
              font-weight: 400;
              width: 290px;
              overflow: hidden;
              text-overflow: ellipsis;
              color: #1e8dff;
              white-space: nowrap;
            }
          }
        }
      }
      &-right {
        flex: 1;
        display: inline-block;
        vertical-align: top;
        background: #f4f9ff;
        border-left: 1px dashed #dfdfdf;
        .top-space {
          height: 45px;
          border-bottom: 1px solid #dfdfdf;
        }
        &-title {
          display: flex;
          justify-content: space-between;
          height: 45px;
          line-height: 45px;
          padding: 0 16px;
          border-bottom: 1px solid #dfdfdf;
          .coupon-amount {
            font-size: 12px;
            font-weight: 500;
            color: #d96900;
          }
        }
        &-content {
          padding: 0 16px 16px 15px;
          &-detail {
            margin-top: 19px;
            img {
              width: 80px;
              height: 80px;
              margin-right: 16px;
            }
            &-des {
              display: inline-block;
              //height: 80px;
              width: 243px;
              font-size: 12px;
              color: #333333;
              line-height: 18px;
              vertical-align: top;
              .name {
                margin-bottom: 3px;
                font-size: 12px;
              }
              .sku {
                margin-bottom: 5px;
              }
              .address {
                font-size: 12px;
                color: #888888;
              }
            }
            &-price {
              display: inline-block;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              vertical-align: top;
              margin-left: 145px;
              width: 88px;
            }
            &-num {
              display: inline-block;
              font-size: 12px;
              font-weight: 400;
              color: #333333;
              vertical-align: top;
              width: 100px;
            }
            &-all {
              float: right;
              font-size: 18px;
              font-weight: 500;
              vertical-align: top;
              color: #d96900;
              margin-top: -4px;
            }
          }
          &-remark {
            font-size: 12px;
            font-weight: 400;
            color: #333333;
            // padding-left: 16px;
            margin-top: 16px;
            .remark-ipt {
              width: 725px;
              height: 28px;
              margin-left: 8px;
              background: rgba(255, 255, 255, 0);

              ::v-deep .el-input__inner {
                height: 28px;
                width: 765px;
                border-color: #dedede;
                border-radius: 0;
              }
            }
            // .remark-ipt::-webkit-input-placeholder {
            //   font-size: 12px;
            //   font-weight: 400;
            //   color: #888888;
            // }
          }
          .price-info {
            display: flex;
            justify-content: flex-end;
            align-items: baseline;
            margin-top: 22px;
            font-size: 14px;
            font-weight: 400;
            color: #333333;
            .yunfei {
              margin: 0 16px;
            }
            .youhui {
              margin-right: 16px;
              .money {
                color: #d96900;
              }
            }
            .total-money {
              .money {
                font-size: 20px;
                color: #d96900;
              }
            }
          }
        }
      }
    }
    .comfirmOrder-invoice-sec {
      .invoice-top {
        display: flex;
        align-items: center;
        height: 44px;
        padding: 16px;
        font-size: 12px;
        font-weight: 400;
        color: #333333;
        background: #fafafa;
        border: 0.5px dashed #8c8c8c;
        .invoice-title {
          margin: 0 16px;
        }
        .change-invoice {
          color: #1e8dff;
          margin-left: 0px;
        }
      }
    }
    .comfirmOrder-pay-sec {
      display: flex;
      justify-content: flex-end;
      .pay-content {
        width: 600px;
        min-height: 128px;
        margin-top: 24px;
        background: #ffffff;
        border: 1px solid #db710e;
        padding-top: 16px;
        padding-right: 16px;
        .pay-content-row {
          display: flex;
          justify-content: flex-end;
          margin-bottom: 10px;
          .row-key {
            font-size: 14px;
            color: #333333;
            text-align: right;
          }

          .row-val {
            font-size: 18px;
            font-weight: 500;
            color: #d96900;
            text-align: right;
            width: 206px;
          }
          // .real-pay-key .real-pay-val {
          //   font-size: 24px;
          //   font-weight: 500;
          // }
        }
        .real-price-row > p {
          font-size: 24px !important;
          // font-weight: 500 !important;
        }
        .orange {
          font-size: 18px;
          color: #d96900;
        }

        .pay-key-list {
          font-size: 14px;
          color: #333333;
          text-align: right;
          > p {
            margin-bottom: 12px;
          }
          .real-price {
            font-size: 24px;
            font-weight: 400;
            color: #333333;
          }
        }
        .pay-val-list {
          font-size: 18px;
          font-weight: 500;
          color: #d96900;
          text-align: right;
          width: 206px;
          padding-right: 16px;
          > p {
            margin-bottom: 10px;
          }
          .real-price-val {
            font-size: 24px;
            font-weight: 500;
            color: #d96900;
          }
        }
      }
      &-remark {
        font-size: 12px;
        color: #333333;
        &-input {
          width: 725px;
          margin-top: 16px;
          ::v-deep .el-input__inner {
            height: 28px;
          }
        }
      }
      &-total {
        text-align: right;
        font-size: 14px;
        color: #333333;
        margin-top: 16px;
        .point {
          font-size: 20px;
          color: #d96900;
        }
      }
    }
  }
  .page-footer {
    background: #fafafa;
    position: fixed;
    z-index: 999;
    bottom: 0;
    left: 0;
    width: 100%;
    &-content {
      display: flex;
      justify-content: flex-end;
      width: 1232px;
      margin: 0 auto;
      padding-left: 16px;
      &__back {
        display: flex;
        align-items: center;
        font-size: 20px;
        font-weight: 400;
        color: #1e8dff;
        margin-right: 48px;
        cursor: pointer;
        .arrow-img {
          width: 24px;
          height: 21px;
          margin-right: 12px;
        }
      }
      &__submitBtn {
        width: 166px;
        height: 70px;
        line-height: 70px;
        text-align: center;
        font-size: 20px;
        font-weight: 400;
        color: #ffffff;
        cursor: pointer;
        background: #1e8dff;
        border: 1px solid #1e8dff;
      }
    }
  }
}
.comfirmOrder-discount {
  min-height: 112px;
  background: #fafafa;
  border: 0.5px dashed #8c8c8c;
  &-title {
    height: 45px;
    line-height: 45px;
    font-size: 12px;
    color: #333333;
    padding: 0 16px;
    .right {
      font-size: 12px;
      color: #1e8dff;
      float: right;
    }
  }
  &-content {
    padding: 0 0 0 16px;
    .all {
      font-size: 14px;
      color: #333333;
      float: right;
      margin-right: 16px;
      margin-top: 30px;
    }
    .point {
      font-size: 20px;
      color: #d96900;
    }
    &-coupon {
      width: 183px;
      height: 52px;
      background: #ffffff;
      border-radius: 2px;
      border: 0.5px dashed #8c8c8c;
      box-sizing: border-box;
      display: inline-block;
      margin-right: 12px;
      margin-bottom: 16px;
      &-des {
        height: 23px;
        line-height: 23px;
        background: linear-gradient(224deg, #9c9c9c 0%, #6d6d6d 100%);
        border-radius: 2px 2px 0px 0px;
        padding: 0 8px;
        .price {
          font-size: 12px;
          color: #ffffff;
        }
        .discount {
          font-size: 12px;
          color: #ffffff;
          float: right;
        }
      }
      &-time {
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        line-height: 29px;
        padding: 0 8px;
      }
    }
    .active {
      .comfirmOrder-discount-content-coupon-des {
        background: linear-gradient(224deg, #409aff 0%, #1e8dff 100%);
      }
      border: 1px dashed #409aff;
    }
  }
  &-content::after {
    content: '';
    display: block;
    clear: both;
    margin-bottom: 16px;
  }
}
.comfirmOrder-invoice {
  height: 44px;
  background: #fafafa;
  border: 0.5px dashed #8c8c8c;
  font-size: 12px;
  color: #333333;
  line-height: 44px;
  padding: 0 16px;
  span {
    margin-right: 16px;
  }
  .edit {
    color: #1e8dff;
    cursor: pointer;
  }
}
.comfirmOrder-account {
  width: 600px;
  height: 164px;
  background: #ffffff;
  border: 1px solid #db710e;
  text-align: right;
  float: right;
  margin-top: 24px;
  padding: 16px;
  margin-bottom: 32px;
  p {
    font-size: 14px;
    color: #333333;
    margin-bottom: 8px;
  }
  .point {
    color: #d96900;
    font-size: 18px;
  }
  .right {
    display: inline-block;
    width: 185px;
  }
  .big {
    font-weight: 500;
    font-size: 24px;
  }
}
.kuaiyao-tag {
  width: 80px !important;
  height: 18.66667px !important;
  margin: 6px 0;
}
.cert-tip {
  margin-top: 30px;
  padding: 8px 0;
  background: #FFF7E6;
  border-radius: 8px;
  font-weight: 400;
  font-size: 12px;
  color: #FF8200;
  line-height: 1;
  font-style: normal;
  text-align: center;
}
</style>
